import {SmartComponent} from "smart-component-js";
import intlTelInput from 'intl-tel-input';

class FormIntTelephone extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.init();
    }

    init() {
        document.addEventListener('yxp-form-loaded', () => {
            const input = document.querySelector('form input[name="telephone"]');
            const intTel = intlTelInput(input, {
                loadUtils: () => import("intl-tel-input/utils"),
                initialCountry: 'it',
                separateDialCode: true
            });
            this.prefixPhone = intTel.getSelectedCountryData().dialCode;
            // listen to the telephone input for changes
            input.addEventListener('countrychange', () => {
                // Prefisso es +39
                this.prefixPhone = intTel.getSelectedCountryData().dialCode;
            });


            const formId = this.element.querySelector('.yxpType_FORM').dataset.yxpFormId;
            this.form = window.youserxp.forms[formId];
            this.form.setCustomValidation = () => {
                // set value phone
                input.value = "+" + this.prefixPhone + " " + input.value
                return {valid: true};
            };
        })

    }
}

export default FormIntTelephone;